import styled from "styled-components/macro";

export const UserInsightsWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;

  .container-wrapper {
    overflow-y: scroll;
    height: calc(100vh - 100px);
    display: flex;
    gap: 24px;
    flex-direction: column;

    /* custom scrollbar */
    &::-webkit-scrollbar {
      height: 8px;
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: var(--Neutral-300);
      border: 1px solid transparent;
      background-clip: content-box;
    }
  }

  .insights-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px 16px 16px;

    .header {
      color: var(--Neutral-100);
      font-size: 22px;
      font-weight: 600;
      line-height: 32px;
      letter-spacing: -0.048px;
    }

    .wrapper {
      display: flex;
      gap: 12px;
    }

    .user-details-left {
      width: 100%;
      display: flex;
      gap: 12px;
      flex-direction: column;
    }

    .user-details-right {
      width: 100%;
      display: flex;
      gap: 12px;
      flex-direction: column;
    }

    .field-wrapper {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .field-label {
      color: var(--Neutral-100);
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: -0.21px;
    }

    .field-value {
      color: var(--Neutral-80);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.014px;

      &.email {
        text-decoration: underline;
        color: var(--Brand-100);
      }
    }
  }
`;

export const Card = styled.div`
  border: 1px solid var(--Neutral-8);
  border-radius: 10px;
  padding: 14px;
  width: 100%;
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 100px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 4px;
`;

export const SummaryLabel = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 16px;
  letter-spacing: -0.018px;
  color: var(--Neutral-60);
`;

export const SummaryValue = styled.span`
  color: var(--Neutral-100);
  font-size: 18px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.048px;
`;

export const ChartContainer = styled.div`
  width: 100%;
  min-height: 300px;

  .highcharts-container {
    .highcharts-title {
      fill: var(--Neutral-100) !important;
      line-height: 32px;
      letter-spacing: -0.048px;
    }

    .highcharts-axis {
      .highcharts-axis-title {
        fill: var(--Neutral-100) !important;
      }
    }
  }
`;

export const LegendRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
`;

export const LegendChip = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  border: 1.5px solid ${({ color }) => color};
  background: ${({ active, color }) => (active ? color + "22" : "transparent")};
  color: ${({ active, color }) => (active ? color : "#9ca3af")};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.18s ease;
  outline: none;

  &:hover {
    background: ${({ color }) => color + "33"};
    color: ${({ color }) => color};
  }
`;

export const LegendDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ color, active }) => (active ? color : "#d1d5db")};
  flex-shrink: 0;
  transition: background 0.18s ease;
`;
